import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { afterItems, beforeItems } from '../data/beforeAfter';
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-40" data-mp="3ofhsf0h6evsg">
      <SectionHeading eyebrow="Before vs. with the pathway" title={<>
            From Starting at Zero to a <em className="text-brand" data-id="element-42" data-mp="3eodjoii3g762">Repeatable Process</em>
          </>} data-id="element-41" data-mp="3sglaltmp53wu" />

      <div className="mx-auto mt-10 grid max-w-6xl grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-43" data-mp="3jhgd8qmvfgm9">
        <div className="rounded-3xl border-2 border-red-200 bg-white p-5 sm:p-8" data-id="element-44" data-mp="34t3ddiknxdmh">
          <div className="flex items-center gap-3" data-id="element-45" data-mp="39q3i9q5s0ac0">
            <span className="grid h-11 w-11 place-items-center rounded-full bg-red-100 text-red-600" data-id="element-46" data-mp="39oipo630v1gs">
              <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-47" data-mp="2vtgeb3feojwl" />
            </span>
            <h3 className="font-serif text-2xl font-extrabold text-ink sm:text-[28px]" data-id="element-48" data-mp="30pdqqynjt643">Before</h3>
          </div>
          <ul className="mt-6 space-y-3" data-id="element-49" data-mp="x6epuhyztwch">
            {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-red-50 px-4 py-3.5" data-id="element-50" data-mp="t2p03p6l18pv">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-51" data-mp="171ygaousg2tu" />
                <span className="text-[16px] leading-snug text-ink/85" data-id="element-52" data-mp="124g6yxcuzllb">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border-2 border-cta bg-white p-5 sm:p-8" data-id="element-53" data-mp="9f9as50vn838">
          <div className="flex items-center gap-3" data-id="element-54" data-mp="9d4wqu99ksp8">
            <span className="grid h-11 w-11 place-items-center rounded-full bg-cta text-white" data-id="element-55" data-mp="o4nlbgg6vvk7">
              <CheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-56" data-mp="jc450bq4ambp" />
            </span>
            <h3 className="font-serif text-2xl font-extrabold leading-tight text-ink sm:text-[28px]" data-id="element-57" data-mp="3rs725njlssls">With the Pathway™</h3>
          </div>
          <ul className="mt-6 space-y-3" data-id="element-58" data-mp="3mtm2pqc6ecye">
            {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-green-50 px-4 py-3.5" data-id="element-59" data-mp="1qpy1xidhegly">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-60" data-mp="1vo9ew1z2p78e" />
                <span className="text-[16px] font-medium leading-snug text-ink" data-id="element-61" data-mp="20hu2d031iitc">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-[21px] font-bold italic leading-snug text-ink sm:text-2xl" data-id="element-62" data-mp="17setafuxr002">
        The difference isn’t having all the answers. It’s knowing how to organize the information and identify what you still need to
        understand.
      </p>

      <CTAButton className="mt-8" label="I want the complete pathway" data-id="element-63" data-mp="1lreeten5iys0" />
    </section>;
}